export function isEmpty(value: any) {
  if (value === undefined || value === null) return true
  else if (Array.isArray(value) && value.length === 0) return true
  return false
}

export function deepClone(value: any) {
  if (typeof value !== 'object' || value === null) return value
  return JSON.parse(JSON.stringify(value))
}



// WEBPACK FOOTER //
// ./src/utils/common.ts